export const grillroom = {
  seo: {
    title: 'Case: Grillroom Istanbul | Bistroo',
    description: 'Discover how Grillroom Istanbul found trust in a reliable online partner and grew its restaurant with Bistroo.',
  },
  hero: {
    title: 'How Grillroom Istanbul finally found real trust in an online partner',
    description:
      'A great example is "Istanbul Grillrestaurant," a popular grillroom located in the lively center of Valkenswaard.',
  },
  testimonials: {
    1: {
      text: '"With Bistroo we quickly save more than 250 euros a month. Through promotions we also saw more customers coming in via Bistroo. This is beneficial for us since these orders cost significantly less in fees."',
      name: 'Hamza',
      job_title: 'Owner',
    },
    2: {
      text: '"With Bistroo we experience a much better collaboration than we were used to. Not such a distant system like others. Plus, we have a lot more control over everything. This gives a reassuring feeling."',
      name: 'Hamza',
      job_title: 'Owner',
    },
  },
  challenge: {
    paragraph: {
      title: 'Finally a fair business model',
      text: 'The restaurant is run by Hamza, who has been with Bistroo for just over a year. Previously, Istanbul Grillrestaurant mainly relied on other online parties that charged high volume-based fees, leading to higher costs and lower margins.',
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: 'Hamza aimed to keep operational costs as low as possible while improving efficiency.',
        2: 'Istanbul Grillrestaurant wanted to recoup its restaurant investment as quickly as possible.',
        3: 'Looking for a reliable partner with a transparent business model.',
        4: '',
      },
    },
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: 'Bistroo provided Istanbul Grillrestaurant with a website and set up their Google My Business, making it easy for customers to place online orders for pickup and delivery.',
      2: 'With Bistroo, Istanbul Grillrestaurant quickly began saving around €250 a month. Thanks to promotional support, Hamza noticed more and more customers coming in via Bistroo — great news, especially at the start of his entrepreneurial journey, since he pays significantly lower fees on these orders. Now, after a year, he is saving an average of €240–250 per month. Nice amounts to reinvest or use to hire an extra delivery driver.',
      3: 'Via the dashboard, Hamza has insight into his customer base. He can see exactly who his biggest customers are and in which regions he has the most clientele.',
      4: 'With Bistroo, Hamza feels much more like he is working with people rather than with a distant system. Compared to other ordering services, where he signed up without ever meeting anyone and had to do all the installation himself, Bistroo offers a personal approach. There is direct contact with someone at Bistroo, resulting in great customer service and easy accessibility.',
      5: "Thanks to Bistroo's online ordering solution, Istanbul Grillrestaurant had a clear overview of orders, reducing errors and misunderstandings while making the kitchen more efficient.",
      6: 'With Bistroo, Istanbul Grillrestaurant could set their own peak hours and better manage busy periods, improving the customer experience and maximizing revenue.',
    },
  },
  conclusion: {
    title: 'The conclusion',
    text: {
      1: "Bistroo's online ordering solution provided Istanbul Grillrestaurant with an effective way to address these challenges and improve their operations. Bistroo came at just the right time with their fair business model compared to other major players in the market. More and more customers — both regulars and new ones — are now coming to Istanbul Grillrestaurant via Bistroo. Bistroo supported them at launch with a flyer campaign, branded bags and stickers.",
      2: "With Bistroo, Hamza feels much more like he is collaborating with people rather than interacting with a distant system. Compared to other ordering services, where he signed up without meeting anyone and had to do all the installation himself, Bistroo offers a personal approach. There is direct contact with someone from Bistroo, resulting in great customer service and easy accessibility.",
    },
  },
}
